import { defineStore } from "pinia"
import axios from "@axios"

export const useMainStore = defineStore("mainStore", {
  state: () => {
    return {
      apiVersion: "v1",
      messages: [],
      posthogSessionId: null,
    }
  },
  actions: {
    parseISOString(string, isForm) {
      if(string) {
        let currentDate = new Date(string)
        let year = currentDate.getFullYear()
        let month = String(currentDate.getMonth() + 1).padStart(2, '0') // Month is zero-based
        let day = String(currentDate.getDate()).padStart(2, '0')
        const hours = String(currentDate.getHours()).padStart(2, '0')
        const minutes = String(currentDate.getMinutes()).padStart(2, '0')
        const seconds = String(currentDate.getSeconds()).padStart(2, '0')

        return isForm ? `${year}-${month}-${day}` : `${day}-${month}-${year} | ${hours}:${minutes}:${seconds}`
      }
    },

    async sortAndPage ({ page, itemsPerPage, sortBy, search }, serverItems) {
      return new Promise(resolve => {
        const start = (page - 1) * itemsPerPage
        const end = start + itemsPerPage

        const items = serverItems.slice().filter(item => {
          return !(search.name && !item.name.toLowerCase().includes(search.name.toLowerCase()))
        })

        if (sortBy.length) {
          const sortKey = sortBy[0].key
          const sortOrder = sortBy[0].order

          items.sort((a, b) => {
            const aValue = a[sortKey]
            const bValue = b[sortKey]
            if (aValue && bValue && isNaN(aValue) && isNaN(bValue) ) {
              return sortOrder === 'desc' ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue)
            }
            else if(aValue && bValue) {
              return sortOrder === 'desc' ? bValue - aValue : aValue - bValue
            }
          })
        }

        const paginated = items.slice(start, end)

        resolve({ items: paginated, total: items.length })
      })
    },

    async addMessage(type, message, title) {
      const mainStore = useMainStore()

      const messageSlot = {
        ...(title) && {
          title: title,
        },
        visible: true,
        type: type,
        message: message,
      }

      mainStore.messages.push(messageSlot)

      setTimeout(() => {
        const index = mainStore.messages.indexOf(messageSlot)
        if (index >= 0) {
          mainStore.messages.splice(index, 1)
        }
      }, 4000)
    },

    async getProductCategoriesSelection(type, maxDepth) {
      try {
        const mainStore = useMainStore()
        const response = await axios.get(`/api/${ mainStore.apiVersion }/product-categories?type=${ type }&max_depth=${ maxDepth }`)
        
        return response.data.data
      } catch (error) {
        console.error(error)
      }
    },
  },
})
